/** The mark a described scenario wears wherever it shows: a type written on the spot, stored nowhere. */

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const DescribedBadge = ({ className }: { className?: string }) => (
  <Badge variant='outline' className={cn('border-teal-200 bg-teal-50 text-[10px] text-teal-700', className)}>
    Described
  </Badge>
);
